import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kontakt',
  templateUrl: './kontakt.component.html',
  styles: []
})
export class KontaktComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
